function HeaderMenuHeader() {
  return (
    <>
        <div class="container">
		  <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
			<a href="/" class="d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none">
			  <svg class="bi me-2" width="40" height="32" role="img" aria-label="Bootstrap"></svg>
			</a>
			<ul class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0" style={{"text-align":"right"}}>
			  <li><a href="/home" class="nav-link px-2 text-white"><i class="fa fa-home"></i> الرئيسية</a></li>
			  <li><a href="/about_us" class="nav-link px-2 text-white"><i class="fa fa-envelope"></i> عنا</a></li>
			  <li><a href="/contact" class="nav-link px-2 text-white"><i class="fa fa-envelope"></i> اتصل بنا</a></li>
			</ul>
		  </div>
		</div>
    </>
  );
}

export default HeaderMenuHeader;

/*
<!-- Navigation
			<form class="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3" role="search">
				<input type="search" class="form-control form-control-dark text-bg-dark" placeholder="Search..." aria-label="Search" />
			  </form>
			<div class="text-end">
			  <button type="button" class="btn btn-outline-light me-2">Login</button>
			  <button type="button" class="btn btn-warning">Sign-up</button>
			</div> -->
*/